export const reportsConstants = {
  FETCH_GRAPH_DATA: 'reports/FETCH_GRAPH_DATA',
  FETCH_EXPORT_LEAD: 'FETCH_EXPORT_LEAD',
};
